import type { DriveStep, Driver } from "driver.js";
import { createGuidedTour } from "./license-setup-tour";

export const AUDIT_REVIEW_TOUR_ID = "audit-review";
export const AUDIT_REVIEW_TOUR_PATH = "/admin/audit";
export const AUDIT_REVIEW_TOUR_HREF = `${AUDIT_REVIEW_TOUR_PATH}?tour=${AUDIT_REVIEW_TOUR_ID}`;

type Translate = (key: string, fallback: string) => string;
type TourOptions = { t: Translate; reduceMotion?: boolean; onDestroyed?: () => void };

export function buildAuditReviewTourSteps(t: Translate): DriveStep[] {
  return [
    { element: '[data-tour-id="audit-target-actor"]', popover: { title: t("help.tour.audit.targetTitle", "Narrow to the relevant record"), description: t("help.tour.audit.targetDescription", "Filter by target or actor when you need evidence for a specific privileged change. Security Admin can also filter by IP."), side: "bottom", align: "start" } },
    { element: '[data-tour-id="audit-action-time"]', popover: { title: t("help.tour.audit.timeTitle", "Set action and time evidence"), description: t("help.tour.audit.timeDescription", "Use an exact action and the displayed timezone range. Submit the filters before reviewing the matching events."), side: "top", align: "start" } },
    { element: '[data-tour-id="audit-export"]', popover: { title: t("help.tour.audit.exportTitle", "Export the matching evidence"), description: t("help.tour.audit.exportDescription", "Export CSV only after the result set is narrow enough for the evidence you need. The export contains the current matching events."), side: "bottom", align: "end" } },
  ];
}

export function createAuditReviewTour(options: TourOptions): Driver {
  return createGuidedTour({ ...options, name: options.t("help.tour.auditName", "Audit review"), steps: buildAuditReviewTourSteps(options.t) });
}
